module.exports = __webpack_public_path__ + "assets/media/day30.b5924d44.mp3";